/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box, Container, Typography } from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import ChatModalManager from "../../app/components/chat-modal-manager";
import ChatModalNew from "../../app/components/chat-modal-new/ChatModalNew";
import Preloader from "../../app/components/preloader";
import HeaderNew from "../../app/components/redesign/Header/HeaderNew";
import { ChatByType, chatListType, TypeChat } from "../../core/api/chatsApi";
import {
  notificationsListType,
  notificationType,
} from "../../core/api/notificationsApi";
import { ROLES, ROUTES } from "../../core/consts/common";
import { COLORS } from "../../core/consts/redesign/commonRedesign";
import { ArrowRight } from "../../core/consts/redesign/icons";
import useIsMobile from "../../core/hooks/useIsMobile";
import chatService from "../../core/services/ChatsService";
import leadsService from "../../core/services/LeadsService";
import notificationsService from "../../core/services/NotificationService";
import { actions } from "../../core/store";
import {
  DocsStatusEnum,
  fieldsProposalItemsType,
  groupFieldsProposalItemsType,
  leadFullInfo,
  leadStatusHistoryType,
} from "../../core/types/leadsApiTypes";
import { clientStatuses } from "../../core/types/managerApiTypes";
import { rootState } from "../../core/types/rootState";
import { transformChatData } from "../../core/utils/chatsUtils";
import IconButtonMain from "../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import StatusCloud from "../../UIcomponentsRedesign/StatusCloud/StatusCloud";
import MessageNewSupport from "../client-messages/components/message/MessageNewSupport";
import MessagesListNewSupport from "../client-messages/components/messages-list/MessagesListNewSupport";
import ChatBlock from "../client-product-details/components/ChatBlock/ChatBlock";
import { useStyles } from "./ClientSupportChatStyles";

/* Redesign . messaging for all */

const ClientMessagesPage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const initialUser = useSelector((state: rootState) => state.currentUser);
  const [notificationsList, setNotificationsList] =
    useState<notificationType[]>();
  const [chatsList, setChatsList] = useState<chatListType[]>();
  const [managerChat, setManagerChat] = useState<chatListType>();
  const [chatsListSearch, setChatsListSearch] = useState<chatListType[]>();
  const [isSearch, setIsSearch] = useState(false);
  const [currentChatId, setCurrentChatId] = useState<string>();
  const [openManagerModal, setOpenManagerModal] = useState(false);
  const [openClientModal, setOpenClientModal] = useState(false);
  const [currentChatClientName, setCurrentChatClientName] = useState<string>();
  const [currentChatRole, setCurrentChatRole] = useState<string>();
  const [noNewMessages, setNoNewMessages] = useState<string>("");
  const [noNewNotifications, setNoNewNotifications] = useState<string>("");
  const [isManagerSupport, setIsManagerSupport] = useState<boolean>();
  const [isShowPreloader, setIsShowPreloader] = useState<boolean>(false);

  const [isShowLeadChat, setIsShowLeadChat] = useState<boolean>(false);
  const [currentLeadId, setCurrentLeadId] = useState<number>();

  const [lead, setLead] = useState<leadFullInfo | null>(null);
  const isMobile = useIsMobile();
  const [showMainStatus, setShowMainStatus] = useState<boolean>(true);
  const [leadStatusHistory, setLeadStatusHistory] = useState<
    leadStatusHistoryType[]
  >([]);
  const [isArchive, setArchive] = useState(false);
  const [allDocPacksStatus, setAllDocPacksStatus] = useState<DocsStatusEnum>(
    DocsStatusEnum.None
  );
  const [commonFields, setCommonFields] = useState<fieldsProposalItemsType[]>(
    []
  );
  const [groupFields, setGroupFields] = useState<
    groupFieldsProposalItemsType[]
  >([]);
  const [currentLeadProduct, setCurrentLeadProduct] = useState<number>();

  // const needDocsCount = useSelector((state: rootState) => selectNeededDocsCountByLeadId(state, leadId));
  const isClient = initialUser.role === ROLES.CLIENT;
  const isAgent = initialUser.role === ROLES.AGENT;
  const isManager = initialUser.role === ROLES.MANAGER;
  const isPartner = initialUser.role === ROLES.PARTNER;
  const dispatch = useDispatch();

  const [renew, setRenew] = useState<boolean>(true);

  const bankIcon = lead?.bank.icon;
  const bankName = lead?.bank.name;
  const leadName = lead?.proposalName;
  const status = lead && lead?.status;
  const archiveLead = lead?.isArchive;
  const statusText = lead && lead?.statusFontColor;
  const statusBg = lead && lead?.statusColor;

  useEffect(() => {
    let Q = {
      onlyUnread: true,
    };
    //initialUser.role !== ROLES.MANAGER &&
    notificationsService
      .getNotificationsListService(Q)
      .then((res: notificationsListType) => {
        if (res.result.length > 0) {
          setNotificationsList(res.result);
        } else {
          setNoNewNotifications("У вас пока нет новых уведомлений");
        }
        setIsShowPreloader(false);
      })
      .catch((error) => {
        console.log(error);
        setIsShowPreloader(false);
      });
  }, [initialUser.role, initialUser.userId]);

  const getUniq = (data: any[]) => {
    const ids: any[] = [];
    const uniqChats: any[] = [];
    data.forEach((item) => {
      if (ids.includes(item.leadId)) {
      } else {
        ids.push(item.leadId);
        uniqChats.push(item);
      }
    });
    return uniqChats;
  };

  useEffect(() => {
    setIsShowPreloader(true);
    chatService
      .getChatsListService()
      .then((res: chatListType[]) => {
        const uniq = getUniq(res);

        if (uniq.length > 0) {
          setChatsList(
            uniq
              .filter((chat: chatListType) => {
                return chat.countUnreadMessage > 0 && chat.lastMessage;
              })
              .concat(
                uniq.filter((chat: chatListType) => {
                  return chat.countUnreadMessage === 0 && chat.lastMessage;
                })
              )
              .filter((item) => item.leadId !== null)
          );
          setManagerChat(uniq.find((item) => item.leadId === null));
        } else {
          setNoNewMessages("У вас пока нет новых сообщений");
        }
        chatsList?.length === 0 &&
          setNoNewMessages("У вас пока нет новых сообщений");
        setIsShowPreloader(false);
      })
      .catch((error) => {
        setIsShowPreloader(false);
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch]);

  // const handleReadAll = () => {
  //   notificationsList?.forEach((notification) => {
  //     notification.actionId !== "1001" &&
  //       notificationsService
  //         .readNotification(notification.id.toString())
  //         .then((res) => {
  //           notification.actionId !== "1001" && setIsRead(true);
  //         })
  //         .catch((error) => {
  //           console.log(error);
  //         });
  //   });
  // };

  const getLeadId = (leadId: number) => {
    setCurrentLeadId(leadId);
  };

  // useEffect(() => {
  //   setIsShowLeadChat(true);
  // }, [currentLeadId])

  const handleChatRouteClick = (chat: chatListType) => {
    if (chat.leadId !== null) {
      actions.setCurrentChatData({
        nameChat: chat.nameChat,
        bankName: chat.bankName,
        avatar_url: chat.avatar_url,
      });
      chat.typeChat === "Bank"
        ? actions.setCurrentChatData({
            isMyMessageBank: chat.lastMessageYou,
            lastMessageBank: chat.lastMessage,
            lastTimeMessageBank: chat.lastTimeMessage,
            countUnreadMessageBank: chat.countUnreadMessage,
          })
        : actions.setCurrentChatData({
            isMyMessage: chat.lastMessageYou,
            lastMessage: chat.lastMessage,
            lastTimeMessage: chat.lastTimeMessage,
            countUnreadMessage: chat.countUnreadMessage,
          });
      if (initialUser.role === ROLES.PARTNER) {
        history.push(`${ROUTES.PARTNER}/application/1/${chat.leadId}`);
      } else {
        getLeadId(chat.leadId);
        setCurrentLeadProduct(chat.productId);
      }
    }
    if (chat.leadId === null && chat.typeChat === "Role") {
      if (initialUser.role === ROLES.MANAGER) {
        setCurrentChatId(chat.id.toString());
        setCurrentChatClientName(chat.nameChat);
        setCurrentChatRole(chat.roleInterlocutor);
        setOpenManagerModal(true);
        setIsManagerSupport(true);
      } else
        history.push(
          `${
            initialUser.role === ROLES.CLIENT
              ? ROUTES.CLIENT
              : initialUser.role === ROLES.PARTNER
                ? ROUTES.PARTNER
                : ROUTES.AGENT
          }/support`
        );
    }
    if (chat.leadId === null && chat.typeChat === TypeChat.ManagerChat) {
      if (initialUser.role === ROLES.MANAGER) {
        setCurrentChatId(chat.id.toString());
        setCurrentChatClientName(chat.nameChat);
        setCurrentChatRole(chat.roleInterlocutor);
        setOpenManagerModal(true);
        setIsManagerSupport(false);
      } else {
        setCurrentChatId(chat.id.toString());
        setOpenClientModal(true);
      }
    }
  };

  useEffect(() => {
    if (currentLeadId && currentLeadId !== 0) {
      leadsService
        .getLeadByIdService(currentLeadId.toString())
        .then((res: leadFullInfo) => {
          if (res) {
            setLead(res);
            setAllDocPacksStatus(res.docsStatus);
            setLeadStatusHistory(res.leadStatusHistory);
            setCommonFields(res.fieldsProposalItems);
            if (res.groupFieldsProposalItems.length > 0) {
              setGroupFields(res.groupFieldsProposalItems);
            }
            setArchive(res.isArchive);
            setIsShowLeadChat(true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [currentLeadId]);

  const handleClientChatClose = () => {
    setOpenClientModal(false);
  };

  //renew for chats
  useEffect(() => {
    if (lead && !lead.isArchive) {
      const timer = setInterval(() => {
        setRenew((prevRenew) => !prevRenew);
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [lead]);

  //sets lead related chats for the role
  useEffect(() => {
    if (lead) {
      if (initialUser.status === clientStatuses.NotCompleteRegistration) {
        return;
      }
      const fetchAndDispatchChat = (
        fetchServiceFunction: () => Promise<ChatByType>
      ): void => {
        fetchServiceFunction()
          .then((res: ChatByType) => {
            dispatch(actions.setChat(transformChatData(res, lead.id)));
          })
          .catch((error: any) => {
            console.error("Failed to fetch chat data:", error);
          });
      };
      const fetchManagerChat = () =>
        chatService.getMessagesListManagerChatByLeadIdService(
          lead.id,
          undefined
        );
      const fetchLeadChat = () =>
        chatService.getMessagesListByLeadIdService(lead.id);
      if (isClient || isAgent) {
        const fetchPromises = [fetchManagerChat()];
        if (lead.hasPartnerChat) {
          fetchPromises.push(fetchLeadChat());
        }
        Promise.all(fetchPromises)
          .then(([managerChatRes, leadChatRes]) => {
            dispatch(
              actions.setChat(transformChatData(managerChatRes, lead.id))
            );
            if (lead.hasPartnerChat && leadChatRes) {
              dispatch(
                actions.setChat(transformChatData(leadChatRes, lead.id))
              );
            }
          })
          .catch((error) => {
            console.error("Failed to fetch chat data:", error);
          });
      } else if (isManager) {
        fetchAndDispatchChat(() =>
          chatService.getMessagesListManagerChatByLeadIdService(
            lead.id,
            undefined
          )
        );
      } else if (isPartner) {
        fetchAndDispatchChat(() =>
          chatService.getMessagesListByLeadIdService(lead.id)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renew, initialUser, lead]);

  const handleBack = () => {
    setIsShowLeadChat(false);
    setCurrentLeadId(undefined);
  };

  return (
    <div>
      {!isShowLeadChat ? (
        <>
          <HeaderNew title={"Поддержка"} />
          <Container className={classes.container}>
            <Box className={classes.pageWrap}>
              {isShowPreloader ? (
                <div style={{ height: "calc(100% - 85px)" }}>
                  <Preloader preloaderType={"block"} sizePixels={"120px"} />
                </div>
              ) : chatsList && chatsList?.length > 0 ? (
                <>
                  {managerChat && (
                    <div style={{ marginBottom: "4px" }}>
                      <MessageNewSupport
                        handleChatRouteClick={handleChatRouteClick}
                        chat={managerChat}
                        initialUser={initialUser}
                        avatar={managerChat.avatar_url}
                        bankIcon={managerChat.bankIcon}
                        isShowLeadChat={isShowLeadChat}
                      />
                    </div>
                  )}
                  <MessagesListNewSupport
                    isSearch={isSearch}
                    handleChatRouteClick={handleChatRouteClick}
                    chatsListSearch={chatsListSearch}
                    chatsList={chatsList}
                    initialUser={initialUser}
                    isShowLeadChat={isShowLeadChat}
                  />
                </>
              ) : (
                <Typography
                  component="span"
                  variant="body1"
                  style={{ display: "block", padding: "15px 0 0 30px" }}
                >
                  {noNewMessages}
                </Typography>
              )}
              {/* </Paper> */}
            </Box>
          </Container>
        </>
      ) : (
        <>
          {currentLeadId && currentLeadProduct && (
            <>
              <HeaderNew
                title={`Чат по заявке ${currentLeadId}`}
                showGoBack={true}
                handleBack={handleBack}
              />
              <Container className={classes.container}>
                <Box className={classes.pageWrap}>
                  <div className={classes.statusBlock}>
                    <div
                      className={classes.Lead__container}
                      id={"lead_title"}
                      style={{
                        padding: isMobile ? "24px 16px 0" : "24px 24px",
                      }}
                    >
                      <div
                        className={classes.Lead__titleRow}
                        onClick={() =>
                          history.push(
                            `${
                              initialUser.role === ROLES.CLIENT
                                ? ROUTES.CLIENT
                                : initialUser.role === ROLES.MANAGER
                                  ? ROUTES.MANAGER
                                  : initialUser.role === ROLES.AGENT &&
                                    ROUTES.AGENT
                            }/product/0/${currentLeadProduct}/${lead?.id}`
                          )
                        }
                      >
                        <div className={classes.titleContainer}>
                          {bankIcon && (
                            <img
                              className={classes.imgIcon}
                              src={bankIcon}
                              alt="Bank icon"
                            />
                          )}
                          <div className={classes.columnBox}>
                            <div className={classes.rowBox}>
                              <Typography
                                variant="body1"
                                style={{ color: COLORS.gray2 }}
                              >
                                {bankName}
                              </Typography>
                              <Typography
                                variant="body1"
                                style={{ fontWeight: 600 }}
                              >
                                {leadName}
                              </Typography>
                            </div>
                            {showMainStatus && (
                              <StatusCloud
                                lowercase
                                id="main-status"
                                status={status}
                                statusBg={statusBg}
                                statusTextColor={statusText}
                              />
                            )}
                            {archiveLead && (
                              <StatusCloud
                                lowercase
                                status={"В архиве"}
                                statusBgRgba="rgba(0, 19, 23, 0.16)"
                                statusTextColorRgba={COLORS.black}
                              />
                            )}
                          </div>
                        </div>
                        <IconButtonMain
                          color="noBgGray"
                          handleClick={() =>
                            history.push(
                              `${
                                initialUser.role === ROLES.CLIENT
                                  ? ROUTES.CLIENT
                                  : initialUser.role === ROLES.MANAGER
                                    ? ROUTES.MANAGER
                                    : initialUser.role === ROLES.AGENT &&
                                      ROUTES.AGENT
                              }/product/0/${currentLeadProduct}/${lead?.id}`
                            )
                          }
                          style={{ width: "24px", height: "24px" }}
                          icon={<ArrowRight />}
                        />
                      </div>
                    </div>
                    {lead && (
                      <ChatBlock leadId={lead.id} isArchive={isArchive} />
                    )}
                  </div>
                </Box>
              </Container>
            </>
          )}
        </>
      )}
      {openManagerModal && (
        <ChatModalManager
          open={openManagerModal}
          close={setOpenManagerModal}
          currentChatId={currentChatId!}
          clientName={currentChatClientName}
          clientRole={currentChatRole}
          isManagerSupport={isManagerSupport}
        />
      )}
      {openClientModal && currentChatId && (
        <ChatModalNew
          open={openClientModal}
          chatId={Number(currentChatId)}
          handleClose={handleClientChatClose}
          chatWithManager={!Boolean(currentLeadId)}
        />
      )}
    </div>
  );
};

export default memo(ClientMessagesPage);
